// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.CreateManualPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateManualPaymentWebApiRequestDto } from '../..';

export const CreateManualPaymentWebApiHandler_createManualPayment_Path = '/api/web/v1/createManualPayment';

/**
 * Create a manual payment
 */
export const CreateManualPaymentWebApiHandler_createManualPayment = (
  postData: CreateManualPaymentWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateManualPaymentWebApiRequestDto, void>(
    {
      endpoint: CreateManualPaymentWebApiHandler_createManualPayment_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
